import React, { Component } from "react";

export class FstyrToast extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showing: false,
      opacity: 0,
      header: "",
      text: "",
      type: "",
      toasts: [],
      index: 0,
    };

    this.show = this.show.bind(this);
  }

  show(header, text, type) {
    this.setState(
      {
        index: (this.state.index += 1),
      },
      () => {
        this.spwanToast(header, text, type, this.state.index);
      }
    );
  }

  spwanToast(header, text, type, id) {
    let toasts = this.state.toasts;
    toasts.push({
      Id: id,
      Toast: {
        Header: header,
        Text: text,
        Type: type,
      },
    });

    this.setState({
      toasts: toasts,
    });
  }

  render() {
    return (
      <div className="fstyr-toast" style={{}}>
        {this.state.toasts.map((value) => {
          return <ToastElement header={value.Toast.Header} text={value.Toast.Text} type={value.Toast.Type} id={value.Id} key={value.Id} />;
        })}
      </div>
    );
  }
}

const colors = {
  success: { hardColor: "#358000", softColor: "#EEFFE2" },
  warning: { hardColor: "#FEBB30", softColor: "#FFEECC" },
  error: { hardColor: "#CC0000", softColor: "#FFE0E0" },
  info: { hardColor: "#1B86C3", softColor: "#E2F2FB" },
};

class ToastElement extends Component {
  constructor(props) {
    super(props);

    this.state = {
      opacity: 1,
      header: "",
      text: "",
      type: "",
      id: 0,
      height: 100,
      marginBottom: 10,
    };
  }

  componentDidMount() {
    this.setState({
      header: this.props.header,
      text: this.props.text,
      type: this.props.type,
      id: this.props.id,
    });
  }

  close() {
    this.timer(5);
  }

  timer(time) {
    setTimeout(
      () =>
        this.setState({ opacity: this.state.opacity - 0.01 }, () => {
          if (this.state.opacity > 0) {
            this.timer(time);
          } else {
            this.setState({ opacity: 0 }, () => {
              this.tranformTimer(2);
            });
          }
        }),
      time
    );
  }

  tranformTimer(time) {
    setTimeout(
      () =>
        this.setState({ height: this.state.height - 5 }, () => {
          if (this.state.height % 10 == 0) {
            this.setState({ marginBottom: this.state.marginBottom - 1 });
          }
          if (this.state.height <= 0) {
            this.setState({ height: 0 });
          } else {
            this.timer(time);
          }
        }),
      time
    );
  }

  //info, success, error, warning
  getIcon() {
    switch (this.state.type) {
      case "info":
        return "i";
      case "success":
        return "+";
      case "error":
        return "x";
      case "warning":
        return "!";
      default:
        return "";
    }
  }

  render() {
    return (
      <div onClick={() => this.close()} id={this.state.id} className="fstyr-toast-container" style={{ backgroundColor: colors[this.props.type].softColor, opacity: this.state.opacity, height: this.state.height, marginBottom: this.state.marginBottom }}>
        <div className="fstyr-toast-logo-container" style={{ backgroundColor: colors[this.props.type].hardColor, pointerEvents: "none" }}>
          <div style={{ pointerEvents: "none" }} className="fstyr-toast-logo">
            {this.getIcon()}
          </div>
        </div>
        <div style={{ pointerEvents: "none" }} className="fstyr-toast-body">
          <p style={{ pointerEvents: "none" }} className="fstyr-toast-body-header">
            {this.props.header}
          </p>
          <p style={{ pointerEvents: "none" }} className="fstyr-toast-body-text">
            {this.props.text}
          </p>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "column", marginRight: 5, pointerEvents: "none" }}>
          <div style={{ pointerEvents: "none" }} className="fstyr-toast-button">
            X
          </div>
        </div>
      </div>
    );
  }
}
